(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
if (!customElements.get('shopping-cart')) {
  customElements.define('shopping-cart', class ShoppingCart extends HTMLElement {

    constructor() {
      super();

      this.toggle = document.querySelector('#cart');
      this.note = this.querySelector('[name="note"]');

      if (this.note) {
        this.note.addEventListener('keyup', this.updateNote.bind(this));
      }

      window.addEventListener('product:added', this.updateCart.bind(this));

      this.addEventListener('change', debounce(this.onChange.bind(this), 300));
    }

    onChange(event) {
      if (event.target.dataset.line) {
        this.updateQuantity(event.target.dataset.line, event.target.value);
      }
    }

    updateNote = debounce(() => {
      const body = JSON.stringify({ note: this.note.value });
      fetch(routes.cart_change_url, { ...fetchConfig(), body });
    }, 250);

    updateCart() {
      this.classList.add('loading');

      fetch(`${window.routes.root_url}?section_id=cart-drawer`)
        .then(r => r.text())
        .then(text => {
          const html = new DOMParser().parseFromString(text, 'text/html');
          this.querySelector('.items').innerHTML = html.querySelector('.items').innerHTML;
          this.querySelector('.footer').innerHTML = html.querySelector('.footer').innerHTML;
          this.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
          this.showCart();
        })
        .catch(() => location.href = window.routes.cart_url)
        .finally(() => this.classList.remove('loading'));
    }

    updateQuantity(line, quantity) {
      const body = JSON.stringify({ line, quantity });

      fetch(routes.cart_change_url, { ...fetchConfig(), body })
        .then(() => this.updateCart());
    }

    showCart() {
      document.documentElement.classList.add('no-scroll');
      this.toggle.checked = true;
    }

    hideCart() {
      document.documentElement.classList.remove('no-scroll');
      this.toggle.checked = false;
    }

  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-filters"]) return;
  try {
    
  if (!customElements.get('collection-filters')) {
    customElements.define('collection-filters', class CollectionFilters extends HTMLElement {
      constructor() {
        super();
      
        this.querySelectorAll('.clear').forEach(element => element.addEventListener('click', this.clear.bind(this)));
      }

      clear() {
        this.querySelectorAll('.options input[type="checkbox"]').forEach(element => element.checked = false);
        this.querySelectorAll('.options input[type="number"]').forEach(element => element.value = '');
        this.querySelectorAll('.price-slider').forEach(element => {
          element.style.setProperty('--range-min', '0%');
          element.style.setProperty('--range-max', '100%');
          document.querySelector('input[type="range"]:first-of-type').value = 0;
          document.querySelector('input[type="range"]:last-of-type').value = document.querySelector('input[type="range"]:last-of-type').max;
        });
      }
    });
  }

  if (!customElements.get('price-range')) {
    customElements.define('price-range', class PriceRange extends HTMLElement {
      constructor() {
        super();

        var _this = this;

        this.rangeLowerBound = this.querySelector('input[type="range"]:first-of-type');
        this.rangeHigherBound = this.querySelector('input[type="range"]:last-of-type');
        this.textInputLowerBound = this.querySelector('input[type="number"][data-from]');
        this.textInputHigherBound = this.querySelector('input[type="number"][data-to]');

        this.textInputLowerBound.addEventListener('change', event => {
          event.target.value = Math.max(Math.min(parseInt(event.target.value), parseInt(_this.textInputHigherBound.value || event.target.max) - 1), event.target.min);
          _this.rangeLowerBound.value = event.target.value;
          _this.rangeLowerBound.parentElement.style.setProperty('--range-min', ''.concat(parseInt(_this.rangeLowerBound.value) / parseInt(_this.rangeLowerBound.max) * 100, '%'));
        });

        this.textInputHigherBound.addEventListener('change', event => {
          event.target.value = Math.min(Math.max(parseInt(event.target.value), parseInt(_this.textInputLowerBound.value || event.target.min) + 1), event.target.max);
          _this.rangeHigherBound.value = event.target.value;
          _this.rangeHigherBound.parentElement.style.setProperty('--range-max', ''.concat(parseInt(_this.rangeHigherBound.value) / parseInt(_this.rangeHigherBound.max) * 100, '%'));
        });

        this.rangeLowerBound.addEventListener('change', event => {
          _this.textInputLowerBound.value = event.target.value;
        });

        this.rangeHigherBound.addEventListener('change', event => {
          _this.textInputHigherBound.value = event.target.value;
        });

        this.rangeLowerBound.addEventListener('input', event => {
          event.target.value = Math.min(parseInt(event.target.value), parseInt(_this.textInputHigherBound.value || event.target.max) - 1);
          event.target.parentElement.style.setProperty('--range-min', ''.concat(parseInt(event.target.value) / parseInt(event.target.max) * 100, '%'));
          _this.textInputLowerBound.value = event.target.value;
        });

        this.rangeHigherBound.addEventListener('input', event => {
          event.target.value = Math.max(parseInt(event.target.value), parseInt(_this.textInputLowerBound.value || event.target.min) + 1);
          event.target.parentElement.style.setProperty('--range-max', ''.concat(parseInt(event.target.value) / parseInt(event.target.max) * 100, '%'));
          _this.textInputHigherBound.value = event.target.value;
        });

      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["instagram"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('instagram-feed')) {
    customElements.define('instagram-feed', class InstagramFeed extends HTMLElement {
      constructor() {
        super();

        const handleIntersection = (entries, observer) => {
          observer.unobserve(this);
          const _this = this;
          const container = this.querySelector('.swyper');

          var loadInstagram = accessToken => {
            var limit	= parseInt(_this.dataset.limit)	? parseInt(_this.dataset.limit)	: 8,
                feed	= new Instafeed({
                  target: container,
                  accessToken: accessToken,
                  limit: limit,
                  template: '<div class="swypee grid-item"><figure class="aspect-ratio aspect-square block relative"><a href="{{link}}" class="block" aria-label="Instagram" target="_blank" rel="noopener noreferrer"><noscript class="loading-lazy"><img src="{{image}}" alt="" draggable="false" loading="lazy" width="auto" height="auto"></noscript></a></figure></div>',
                  filter: image => {
                    return image.type === 'image';
                  },
                  after: () => {
                    this.dispatchEvent(new CustomEvent('images:loaded', { bubbles: true }));
                    _this.closest('.shopify-section').classList.remove('hidden');
                  },
                  error: () => {
                    console.error('Instagram error.');
                    sessionStorage.removeItem('InstagramToken');
                  }
                });
            feed.run();
            
            try {
              sessionStorage.setItem('InstagramToken', accessToken);
            } catch (e) {
              // No local storage.
            }
          };

          var loadInstafeed = accessToken => {
            var scriptTag = document.createElement('script');
            scriptTag.src = window.routes.asset_url + 'instafeed.js';
            scriptTag.onload = function(){ loadInstagram(accessToken); };
            scriptTag.onreadystatechange	= function(){ loadInstagram(accessToken); };
            document.body.appendChild(scriptTag);
          };
          
          var sessionToken;
          try {
            sessionToken = sessionStorage.getItem('InstagramToken');
          } catch (e) {
            // Not set.
          }
          
          if (sessionToken && sessionToken) {
            loadInstafeed(sessionToken);
          } else {
            fetch(_this.dataset.token)
            .then(response => response.json())
            .then(data => {
              if (data.Token) {
                loadInstafeed(data.Token)
              } else {
                console.error(`Instagram error.`, data['Error']);
                sessionStorage.removeItem('InstagramToken');
              }
            })
            .catch(error => {
              console.error(`Instagram error.`, error);
              sessionStorage.removeItem('InstagramToken');
            });
          }
        }

        new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-main"]) return;
  try {
    
  if (!customElements.get('gallery-nav')) {
    customElements.define('gallery-nav', class GalleryNav extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.gallery = document.querySelector('.product-images .images[data-model="' + this.dataset.model + '"]');
        this.images = this.gallery.querySelectorAll('.swypee');
        this.progress = this.querySelector('span');
        
        this.init();
      }

      update(event) {
        if (!this.gallery.scrollWidth || !this.gallery.clientWidth) return;

        const scrollableWidth = this.gallery.scrollWidth - this.gallery.clientWidth;
        if (scrollableWidth <= 0) {
          this.progress.style.left = '0%';
          return;
        }
        
        const scrollPercentage = this.gallery.scrollLeft / scrollableWidth;
        const maxLeft = 100 - parseFloat(this.progress.style.width) + 1;
        const newLeft = scrollPercentage * maxLeft;

        this.progress.style.left = `${newLeft}%`;
      }

      init() {
        if (this.dataset.model) {
          var total = this.closest('.product-images').querySelectorAll(`.images[data-model="${this.dataset.model}"] figure`).length;
        } else {
          var total = this.closest('.product-images').querySelectorAll('.images figure').length;
        }

        this.progress.style.width = `${100 / total}%`;

        this.gallery.addEventListener('scroll', this.update.bind(this));
        this.gallery.addEventListener('mousemove', this.update.bind(this));
        this.gallery.addEventListener('touchend', this.update.bind(this));
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
